/**
 * Application-level permissions (canonical source of truth).
 *
 * These strings control UI features and actions beyond FHIR resource access.
 * They are granted to a user via the practitioner-app-permissions extension on
 * their AccessPolicy role and surfaced through the `User/$get-permissions`
 * operation.
 *
 * Every concrete permission below (all except the `SUPERADMIN` wildcard) MUST
 * exist as a concept in the `app-permissions` CodeSystem
 * (`apps/ig/input/resources/code-systems/app-permissions.json`). The unit test
 * in `app-permissions.test.ts` asserts the two stay in sync — add a concept to
 * the CodeSystem and regenerate before adding an entry here.
 *
 * `SUPERADMIN` (`*`) is a wildcard that grants every permission; it is not a
 * CodeSystem concept.
 *
 * Consumed by both the web app (`apps/web/src/lib/auth/permissions.ts`) and the
 * Medplum bots (`apps/medplum/bots/**`).
 */
export const APP_PERMISSIONS = {
    SUPERADMIN: '*',
    MANAGE_USERS: 'manage_users',
    ENTITY_ADMIN: 'entity_admin',
    ADMIN_DASHBOARD: 'admin_dashboard',
    ENROLLMENT_ADMIN: 'enrollment_admin',
    PATIENT_ENROLLMENT: 'patient_enrollment',
    CARE_ADMIN: 'care_admin',
    PATIENT_CARE: 'patient_care',
    PATIENT_MEDREC: 'patient_medrec',
    PROVIDER_ADMIN: 'provider_admin',
    FACILITIES_ADMIN: 'facilities_admin',
    PHARMACY_ADMIN: 'pharmacy_admin',
    GENESYS_ADMIN: 'genesys_admin',
    VIEW_DASHBOARD: 'view_dashboard',
    EDIT_TASKS: 'edit_tasks',
    ASSIGN_TASK: 'assign_task',
    VIEW_REPORTS: 'view_reports',
};
